import { Link } from "react-router-dom";
import { Section, Reveal, Empty } from "@/components/site/Primitives";
import { ServiceCard, PriceTag } from "@/components/site/ServiceCard";
import { gstLine } from "@/lib/format";

export const ServicesSection = ({ meta, index, services }) => (
  <Section id="services" index={index} title={meta.title} subtitle={meta.subtitle}
    action={<Link to="/services" className="eb-btn-ghost" data-testid="view-all-services">All services</Link>}>
    {services.length === 0 ? (
      <Empty title="Services are being updated." body="Send us your brief and we'll recommend the right scope." />
    ) : (
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.06}><ServiceCard service={s} index={i} /></Reveal>
        ))}
      </div>
    )}
  </Section>
);

export const PricingSection = ({ meta, index, services, site }) => {
  const fixed = services.filter((s) => !s.custom_quote && s.price_inr != null);
  const custom = services.filter((s) => s.custom_quote || s.price_inr == null);
  const pricing = site.pricing || {};
  return (
    <Section id="pricing" index={index} title={meta.title} subtitle={meta.subtitle} className="bg-[#0a0a0a] border-y border-[#27272A]">
      {pricing.show_promo && pricing.promo_text && (
        <p className="mb-8 inline-block border border-[#0055FF] text-[#00E5FF] px-4 py-2 text-sm" data-testid="pricing-promo">{pricing.promo_text}</p>
      )}
      <div className="grid lg:grid-cols-12 gap-px bg-[#27272A] border border-[#27272A]">
        <div className="lg:col-span-7 bg-[#050505] p-8 md:p-12 space-y-10">
          {fixed.map((s) => (
            <div key={s.id} data-testid={`pricing-fixed-${s.slug}`}>
              <p className="eb-label mb-3">{s.name}</p>
              <PriceTag service={s} large />
              <p className="mt-4 text-zinc-400 max-w-md">{s.summary}</p>
            </div>
          ))}
          {pricing.scope_note && <p className="text-sm text-zinc-500 max-w-lg" data-testid="pricing-scope-note">{pricing.scope_note}</p>}
          <Link to="/pricing" className="eb-btn-primary" data-testid="pricing-details-btn">See full pricing</Link>
        </div>
        <div className="lg:col-span-5 bg-[#050505] flex flex-col">
          {custom.map((s) => (
            <div key={s.id} className="p-8 md:p-10 border-b border-[#27272A] last:border-b-0" data-testid={`pricing-custom-${s.slug}`}>
              <p className="eb-label">{s.category}</p>
              <p className="mt-2 text-2xl font-display font-bold">{s.name}</p>
              <p className="mt-1 text-[#00E5FF] text-sm">Custom quote</p>
              <p className="mt-3 text-zinc-500 text-sm">{s.turnaround_text}</p>
            </div>
          ))}
          <p className="p-8 md:p-10 mt-auto text-xs text-zinc-600" data-testid="pricing-gst-note">{gstLine(pricing)}</p>
        </div>
      </div>
    </Section>
  );
};
